module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#text",
      toString: function () {
        return this.url;
      }
    }